import CityPageTemplate from "../city-template/CityPageTemplate";
import { danvilleVaConfig } from "./data";

export default function DanvilleVaPage() {
  return <CityPageTemplate config={danvilleVaConfig} />;
}